<template>
  <b-modal v-model="active" size="lg" centered hide-footer no-close-on-backdrop body-class="p-0"
           @hidden="reset">
    <template #modal-title>{{ $t("Provider") }}</template>
    <div>
      <b-card-body v-if="provider != null">
        <b-row>
          <b-col cols="6">
            <b-form-group :label="$t('Name')">
              <b-form-input v-model="provider.name"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group :label="$t('Contact Person')">
              <b-form-input v-model="provider.contactPerson"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group :label="$t('Description')">
              <b-form-input v-model="provider.description"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group :label="$t('Address')">
              <b-form-input v-model="provider.address"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group :label="$t('Phone')">
              <b-form-input v-model="provider.phone"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group :label="$t('Email')">
              <b-form-input v-model="provider.email"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group :label="$t('Website')">
              <b-form-input v-model="provider.website"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group :label="$t('Branches')">
              <v-select
                  multiple
                  v-model="provider.buIds"
                  :options="allBranches"
                  class="w-100"
                  label="name"
                  :reduce="(branch) => branch.id"
                  :clearable="false"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-button block variant="primary" @click="saveProvider" v-bind:disabled="busy">
              {{$t('Save')}}
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </div>
  </b-modal>
</template>
<script>
import {mapActions, mapGetters} from "vuex";

const generateProvider = (provider) => {
  provider = provider || {};
  return {
    id: provider.id || null,
    buIds: provider.buIds || [],
    name: provider.name || null,
    description: provider.description || null,
    address: provider.address || null,
    phone: provider.phone || null,
    email: provider.email || null,
    website: provider.website || null,
    contactPerson: provider.contactPerson || null,
    contactPhone: provider.contactPhone || null,
    contactEmail: provider.contactEmail || null,
  }
}

export default {
  name: "ProviderModal",
  data:() => ({
    active: false,
    loading: false,
    busy: false,
    providerId: null,
    provider: null,
  }),
  computed:{
    ...mapGetters('data',['getAllBranches']),
    isNewProvider(){
      return this.providerId == null;
    },
    allBranches(){
      return Object.values(this.getAllBranches);
    },
  },
  methods:{
    ...mapActions('providers', ['fetchProviderById','insertProviders','updateProviders']),
    show(providerId){
      if(providerId == null){
        this.provider = generateProvider();
      }else {
        this.providerId = providerId;
        this.refresh();
      }
      this.active = true;
    },
    refresh(){
      if(this.providerId == null){
        return;
      }
      let $this = this;
      this.loading = true;
      this.fetchProviderById(this.providerId).then(provider => {
        $this.provider = generateProvider(provider);
      }).catch(()=>{
        $this.active = false;
      }).finally(() => {
        $this.loading = false;
      })
    },
    reset(){
      this.active = false;
      this.provider = null;
      this.providerId = null;
    },
    saveProvider() {
      let body = generateProvider(this.provider);
      let $this = this;
      this.busy = true;
      let request = null;
      if (this.isNewProvider) {
        request = this.insertProviders(body)
      } else {
        request = this.updateProviders({id: this.providerId, request: body});
      }
      request.then(provider => {
        console.log("saveProvider", provider)
        $this.$emit('updated', provider);
        $this.providerId = provider.id;
        $this.reset();
      },()=>{}).catch(() => {
        $this.active = false;
      }).finally(() => {
        $this.busy = false;
      })
    }
  }
}
</script>



<style scoped>

</style>